import { Routes } from '@angular/router';
import { BrochureType01Component } from './brochure-type01/brochure-type01.component';

export default [
    {
        path     : '',
        component: BrochureType01Component,
    },
    
] as Routes;
